import React, { useEffect } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import componentQueries from 'react-component-queries';
import { EmptyLayout, LayoutRoute, MainLayout } from 'components/Layout';
import PageSpinner from 'components/PageSpinner';
import GAListener from 'components/GAListener';
import AuthPage from 'pages/AuthPage';
import jwt from 'jsonwebtoken';
import './styles/reduction.scss';
import { STATE_LOGIN, STATE_SIGNUP } from 'components/AuthForm';

// Lazy-loaded components
const CardPage = React.lazy(() => import('pages/CardPage'));
const ChartPage = React.lazy(() => import('pages/ChartPage'));
const Userpage = React.lazy(() => import('pages/User'));
const WidgetPage = React.lazy(() => import('pages/WidgetPage'));
const InspectionPage = React.lazy(() => import('pages/Inspection'));
const InspectionPage2 = React.lazy(() => import('pages og code/Inspection'));
const InspectionEdit = React.lazy(() => import('pages/InspectionEdit'));
const Dashboard = React.lazy(() => import('pages/Dashboard'));
const Factorordersheet = React.lazy(() => import('pages/Factorordersheet'));
const InspectionReport = React.lazy(() => import('pages/InspectionReport'));
const InspectionReportsummary = React.lazy(() =>
  import('pages/InspectionReportSummary'),
);
const Defactdescription = React.lazy(() => import('pages/Defactdescription'));
const Viewdocs = React.lazy(() => import('pages/Viewdocs'));
const logout = React.lazy(() => import('pages/Logout'));
const Home = React.lazy(() => import('pages/Home'));
const Userrights = React.lazy(() => import('pages/Userrights'));
const AuditMst = React.lazy(() => import('pages/Auditmst'));
const data = React.lazy(() => import('pages/chartdata'));
// masters
const DivisonMst = React.lazy(() => import('pages/DivisionMaster'));
const Department = React.lazy(() => import('pages/DepartmentMaster'));
const companylog = React.lazy(() => import('pages/Companylogmaster'));
const Designation = React.lazy(() => import('pages/DesignationMaster'));
const SeasonMst = React.lazy(() => import('pages/SeasonMaster'));
const GarmentMast = React.lazy(() => import('pages/GarmentMaster'));
const color = React.lazy(() => import('pages/ColorMaster'));
const UOM = React.lazy(() => import('pages/UOMmaster'));
const Currency = React.lazy(() => import('pages/CurrencyMaster'));
const country = React.lazy(() => import('pages/CountryMaster'));
const Company = React.lazy(() => import('pages/CompanyMaster'));
const BuyerGroup = React.lazy(() => import('pages/BuyerGroup'));
const BuyerMast = React.lazy(() => import('pages/BuyerMaster'));
const Supplier = React.lazy(() => import('pages/SupplierMaster'));
const Supplier2 = React.lazy(() => import('pages og code/SupplierMaster'));
const Fabric = React.lazy(() => import('pages/FabricMaster'));
const Buyeroders = React.lazy(() => import('pages/BuyerOrder'));
const Buyerodersedit = React.lazy(() => import('pages/CreateBuyerOrder'));
const userrole = React.lazy(() => import('pages/Userrole'));
// transactions
const Buyerorder = React.lazy(() => import('pages/CreateBuyerOrder'));
const workorder = React.lazy(() => import('pages/CreateWorkOrder'));
const workorderview = React.lazy(() => import('pages/Workorder'));
const buyersize = React.lazy(() => import('pages/BuyersizeRange'));
const buyersizedetail = React.lazy(() => import('pages/Buyersizedetail'));
const Pommaster = React.lazy(() => import('pages/POMmaster'));
const transactionimport = React.lazy(() => import('pages/Transactionmport'));
const AssignOrderForInspection = React.lazy(() => import('pages/AssignOrderForInspection'));
const AssignorderReport = React.lazy(() => import('pages/AssignorderReport'));
// reports
const BookedorderReport = React.lazy(() => import('pages/BookedorderReport'));
const App = ({ breakpoint }) => {
  return (
    <BrowserRouter basename={getBasename()}>
      <GAListener>
        <Switch>
          <LayoutRoute
            exact
            path="/"
            layout={EmptyLayout}
            component={props => <AuthPage {...props} authState={STATE_LOGIN} />}
          />
          <LayoutRoute
            exact
            path="/signup"
            layout={EmptyLayout}
            component={props => (
              <AuthPage {...props} authState={STATE_SIGNUP} />
            )}
          />

          <MainLayout breakpoint={breakpoint}>
            <React.Suspense fallback={<PageSpinner />}>
              <Route exact path="/chh" component={data} />
              <Route exact path="/login" component={AuthPage} />
              <Route exact path="/Dashboard" component={Dashboard} />
              <Route exact path="/Qaparameter" component={CardPage} />
              <Route exact path="/Subcategory" component={WidgetPage} />
              <Route exact path="/user" component={Userpage} />
              <Route exact path="/Department" component={Department} />
              <Route exact path="/Designation" component={Designation} />
              
              <Route exact path="/companylog" component={companylog} />
          
              
              <Route exact path="/Transactionimport" component={transactionimport} />
         
              <Route
                exact
                path="/Factoryordersheet"
                component={Factorordersheet}
              />
                  <Route exact path="/BookedorderReport" component={BookedorderReport} />
              <Route exact path="/logout" component={logout} />
              <Route exact path="/Home" component={Home} />
              <Route exact path="/Userrights" component={Userrights} />
              <Route exact path="/Division" component={DivisonMst} />
              <Route exact path="/inspection" component={InspectionPage} />  
              <Route exact path="/inspection2" component={InspectionPage2} />        
              <Route exact path="/defactcategory" component={ChartPage} />
              <Route exact path="/userrole" component={userrole} />
              
              <Route
                exact
                path="/inspectionModify"
                component={InspectionEdit}
              />
              <Route exact path="/inspection/:id" component={InspectionPage} />
              <Route exact path="/inspection2/:id" component={InspectionPage2} />
              <Route
                exact
                path="/inspectionsummary"
                component={InspectionReport}
              />
              <Route
                exact
                path="/inspectionReport"
                component={InspectionReportsummary}
              />
              <Route exact path="/viewdocs/:id" component={Viewdocs} />
              <Route exact path="/Auditmst" component={AuditMst} />
              <Route exact path="/Season" component={SeasonMst} />
              <Route exact path="/Garment" component={GarmentMast} />
              <Route exact path="/Color" component={color} />
              <Route exact path="/UOM" component={UOM} />
              <Route exact path="/Currency" component={Currency} />
              <Route exact path="/country" component={country} />
              <Route exact path="/Company" component={Company} />
              <Route exact path="/BuyerGroup" component={BuyerGroup} />
              <Route exact path="/Buyer" component={BuyerMast} />
              <Route exact path="/Supplier" component={Supplier} />              
              <Route exact path="/Supplier2" component={Supplier2} />
              <Route exact path="/BuyerOrder" component={Buyerorder} />
              <Route exact path="/Fabric" component={Fabric} />
              <Route exact path="/Buyeroderview" component={Buyeroders} />
              <Route exact path="/BuyerOrder/:id" component={Buyerodersedit} />
              <Route exact path="/CreateWorkorder/:id" component={workorder} />
              <Route exact path="/CreateWorkorder" component={workorder} />
              <Route exact path="/Workorderview" component={workorderview} />
              <Route exact path="/BuyersizeRange" component={buyersize} />
              <Route exact path="/AssignOrderForInspection" component={AssignOrderForInspection} /> 
              <Route exact path="/AssignorderReport" component={AssignorderReport} />
              <Route
                exact
                path="/Buyersizedetail"
                component={buyersizedetail}
              />
              <Route exact path="/POM" component={Pommaster} />
            </React.Suspense>
          </MainLayout>
          <Redirect to="/" />
        </Switch>
      </GAListener>
    </BrowserRouter>
  );
};

const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split('/').pop()}`;
};

const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: 'xs' };
  }

  if (576 < width && width < 767) {
    return { breakpoint: 'sm' };
  }

  if (768 < width && width < 991) {
    return { breakpoint: 'md' };
  }

  if (992 < width && width < 1199) {
    return { breakpoint: 'lg' };
  }

  if (width > 1200) {
    return { breakpoint: 'xl' };
  }

  return { breakpoint: 'xs' };
};

export default componentQueries(query)(App);
